import { useState, useEffect } from 'react';
import Text from '@/components/common/Text';
import DateRangePicker from '@/components/common/DateRangePicker';
import type { UserFilterType } from '@/types/admin.types';
import * as S from './style';

interface UserFiltersProps {
  filters: UserFilterType;
  onFilterChange: (filters: UserFilterType) => void;
  onReset: () => void;
}

const UserFilters = ({
  filters,
  onFilterChange,
  onReset,
}: UserFiltersProps) => {
  const [localFilters, setLocalFilters] = useState(filters);

  // Sync localFilters with filters prop when it changes
  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleChange = (key: string, value: any) => {
    const newFilters = { ...localFilters, [key]: value };
    setLocalFilters(newFilters);
  };

  const handleApply = () => {
    onFilterChange(localFilters);
  };

  const handleReset = () => {
    const resetFilters: UserFilterType = {
      search: undefined,
      subscription_status: undefined,
      start_date: undefined,
      end_date: undefined,
      user_type: undefined,
    };
    setLocalFilters(resetFilters);
    onReset();
  };

  return (
    <S.FilterContainer>
      <S.FilterRow>
        <S.FilterItem>
          <Text fontSize='0.875rem' fontWeight={600}>
            검색:
          </Text>
          <S.Input
            type='text'
            placeholder='회사명, 이메일, 연락처'
            value={localFilters.search || ''}
            onChange={(e) => handleChange('search', e.target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleApply();
              }
            }}
          />
        </S.FilterItem>

        <S.FilterItem>
          <Text fontSize='0.875rem' fontWeight={600}>
            구독 상태:
          </Text>
          <S.Select
            value={localFilters.subscription_status || 'all'}
            onChange={(e) =>
              handleChange('subscription_status', e.target.value === 'all' ? undefined : e.target.value)
            }
          >
            <option value='all'>전체</option>
            <option value='free'>무료</option>
            <option value='active'>유료</option>
            <option value='expired'>만료됨</option>
          </S.Select>
        </S.FilterItem>

        <S.FilterItem>
          <Text fontSize='0.875rem' fontWeight={600}>
            가입일:
          </Text>
          <DateRangePicker
            startValue={localFilters.start_date}
            endValue={localFilters.end_date}
            onStartChange={(value) => handleChange('start_date', value || undefined)}
            onEndChange={(value) => handleChange('end_date', value || undefined)}
            startPlaceholder='연도-월-일'
            endPlaceholder='연도-월-일'
          />
        </S.FilterItem>

        <S.FilterItem>
          <Text fontSize='0.875rem' fontWeight={600}>
            사용자 유형:
          </Text>
          <S.Select
            value={localFilters.user_type || 'all'}
            onChange={(e) =>
              handleChange('user_type', e.target.value === 'all' ? undefined : e.target.value as 'user' | 'admin')
            }
          >
            <option value='all'>전체</option>
            <option value='user'>일반 사용자</option>
            <option value='admin'>관리자</option>
          </S.Select>
        </S.FilterItem>
      </S.FilterRow>

      <S.FilterRow>
        <S.ButtonContainer>
          <S.Button onClick={handleApply}>적용</S.Button>
          <S.Button onClick={handleReset}>초기화</S.Button>
        </S.ButtonContainer>
      </S.FilterRow>
    </S.FilterContainer>
  );
};

export default UserFilters;

